import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './styles.css';
import { Typography } from '../../../Typography';
import { Button } from '../../../Button';

export interface ISuccessScreenProps {
  title: string;
  onClose: () => void;
}

export const ApplyError: React.FC<ISuccessScreenProps> = ({ title, onClose }) => {
  const deviceType = useDeviceType();

  return (
    <div className={styles.wrapper}>
      <div className={styles.text}>
        <Typography.Title level={deviceType === 'desktop' ? 5 : 6}>{title}</Typography.Title>
        <Typography.Text level={3}>Повторный отклик можно отправить через 5 минут</Typography.Text>
      </div>

      <div className={styles.button}>
        <Button onClick={onClose} fullWidth>
          Хорошо
        </Button>
      </div>
    </div>
  );
};
